export default __webpack_public_path__ + "static/media/404.937cd268.jpg";